import { Route, Routes } from 'react-router-dom';

import { TransactionList } from './routes/TransactionList';

export const Transactions = () => (
  <Routes>
    <Route index element={<TransactionList />} />
  </Routes>
);
